<template>
<tbody v-bind:class="{'akg-tables':true,
                          'drag':  isDragEffect,
                          'drop':  isDropEffect && !isDragEffect
                          }" id="3" :draggable="!akgTable.isDisabled" @drop="drop_handler" @dragleave="drag_leave_handler" @dragover="dragover_handler" @dragstart="dragstart_handler">
    <tr>
        <th style="min-width: 70px;">
            <div v-tooltip="'A tábla sorszáma'" class='akg-table-header-element mt-2'>
                Azonosító
            </div>
        </th>
        <th class="nowrap" style="min-width: 90px">
            <div v-tooltip="'A tábla elnevezése.'" class="akg-table-header-element mt-2">
                Terület Neve
            </div>
        </th>
        <th style="min-width: 70px">
            <div class="akg-table-header-element mt-2" v-tooltip="'A tábla területe.'">
                Terület
            </div>
        </th>
        <th class="nowrap" v-tooltip="'A helyes számítások érdekében kérjük, hogy a megfelelő csoportból válassza ki az ön számára megfelelő kódot.'">
            <div class="akg-table-header-element mt-2">
                Haszn. Kód
            </div>
        </th>
        <th>
            <div class="akg-table-header-element mt-2"  v-bind:class="{'akg-table-copy dropdown-copy disabled':akgTable.isDisabled}">
                <a v-if="!akgTable.isDisabled"
                       aria-hidden="true"
                       class="akg-table-copy dropdown-copy">
                        <i class="akg-table-copy fa fa-arrows">
                        </i>
                    </a>
            </div>
        </th>
    </tr>
    <tr>
        <td>
            <div class="form-group">
                <input class="form-control form-control-sm"
                           placeholder="ID."
                           :disabled="akgTable.isDisabled"
                           v-bind:class="{'is-invalid':$v.akgTable.identification.$error,
                                          'is-valid':  $v.akgTable.identification.$dirty}"
                           v-model.trim="akgTable.identification"
                           @input="$v.akgTable.identification.$touch()">
                <transition name="fade">
                    <span class="invalid-feedback"
                              v-if="! $v.akgTable.identification.numeric">
                            Az azonositónake számnak kell lennie.
                        </span>
                </transition>

            </div>
        </td>
        <td>
            <div class="form-group">
                <input placeholder="Név..."
                           :disabled="akgTable.isDisabled"
                           class="form-control form-control-sm"
                           v-bind:class="{'is-invalid':$v.akgTable.name.$error,
                                           'is-valid':  $v.akgTable.name.$dirty }"
                           v-model.trim="akgTable.name"
                           @input="$v.akgTable.name.$touch()">
                <transition name="fade">
                    <span class="invalid-feedback"
                              v-if="! $v.akgTable.name.maxLength">
                            Az név maximum {{ $v.akgTable.name.$params.maxLength.max }} karakterből álhat.
                        </span>
                </transition>

            </div>
        </td>
        <td>
            <div class="form-group">
                <input class="form-control form-control-sm"
                           :disabled="akgTable.isDisabled"
                           v-tooltip="'Az elsödleges vetés területe '+akgTable.area_one+' (ha)'"
                           v-bind:class="{'is-invalid':!area_one_is_valid ||  parseFloatValue(ketArea) < parseFloatValue(akgTable.area_one),
                                          'is-valid':  area_one_is_valid}"
                           type="text"
                           placeholder="Ter. 1."
                           v-model="akgTable.area_one">
                <transition name="fade">
                    <span class="invalid-feedback"
                              v-if="!area_one_is_valid">
                            Az területnek számnak kell lennie.
                        </span>
                </transition>
                <transition name="fade">
                    <span class="invalid-feedback"
                              v-if="parseFloatValue(ketArea) < parseFloatValue(akgTable.area_one)">
                            A terület nem lehet nagyobb mint a KET területe: {{ketArea}} ha.
                        </span>
                </transition>
            </div>
        </td>
        <td>
            <div class="form-group akg-table-select">
                <select2 v-if="akgProgramId === 9" :width="'77px'" :disabled="akgTable.isDisabled" :placeholder="'Kód...'" v-model="akgTable.utilization_id_one">
                    <option disabled value="0">Kód...</option>
                    <optgroup v-for="(group, key) in tableCodes" :key="key" :label="group.text">
                        <option v-for="(code, ckey) in group.children" :key="ckey" v-if="!code.hasHoe" :value="code.id">{{code.text}}</option>
                    </optgroup>
                </select2>
                <select2 v-else :width="'77px'" :disabled="akgTable.isDisabled" :placeholder="'Kód...'" v-model="akgTable.utilization_id_one">
                    <option disabled value="0">Kód...</option>
                    <optgroup v-for="(group, key) in tableCodes" v-if="group.id !==6" :key="key" :label="group.text">
                        <option v-for="(code, ckey) in group.children" :key="ckey" :value="code.id">{{code.text}}</option>
                    </optgroup>
                </select2>
            </div>
        </td>

        <coppy-ket-row-table v-if="lastElement<4  && !akgTable.isDisabled && akgTable.utilization_id_one !==codeATAD" :actualTable="akgTable" :rowTables="tables"></coppy-ket-row-table>
    </tr>
    <tr>
        <td colspan="2">

        </td>
        <td>
            <div class="form-group">
                <input class="form-control form-control-sm"
                           :disabled="akgTable.isDisabled || akgTable.utilization_id_one== codeATAD"
                           v-tooltip="akgTable.utilization_id_one == codeKEV ? 'Az elsödleges vetés területe '+akgTable.area_two+' (ha)'  :'A másodvetés területe '+akgTable.area_two+' (ha)'"
                           v-bind:class="{'is-invalid':!area_two_is_valid ||  parseFloatValue(ketArea) < parseFloatValue(akgTable.area_two),
                                           'is-valid':area_two_is_valid }"
                           type="text"
                           placeholder="Ter. 2."
                           v-model="akgTable.area_two">

                <transition name="fade">
                    <span class="invalid-feedback"
                              v-if="!area_two_is_valid">
                            Az területnek számnak kell lennie.
                        </span>
                </transition>
                <transition name="fade">
                    <span class="invalid-feedback"
                              v-if="parseFloatValue(ketArea) < parseFloatValue(akgTable.area_two)">
                            A terület nem lehet nagyobb mint a KET területe: {{ketArea}} ha.
                        </span>
                </transition>
            </div>
        </td>
        <td>
            <div class="form-group">
                <select2 class="akg-table-select" v-if="akgProgramId === 9" :disabled="akgTable.isDisabled  || akgTable.utilization_id_two ==codeATAD" :width="'77px'" :placeholder="'Kód...'" v-model="akgTable.utilization_id_two">
                    <option disabled value="0">Kód...</option>
                    <optgroup v-for="(group, key) in tableCodes" v-if="group.id !==7" :key="key" :label="group.text">
                        <option v-for="(code, ckey) in group.children" v-if="!code.hasHoe" :key="ckey" :value="code.id">{{code.text}}</option>
                    </optgroup>
                </select2>
                <select2 class="akg-table-select" v-else :disabled="akgTable.isDisabled  || akgTable.utilization_id_two ==codeATAD" :width="'77px'" :placeholder="'Kód...'" v-model="akgTable.utilization_id_two">
                    <option disabled value="0">Kód...</option>
                    <optgroup v-for="(group, key) in tableCodes" v-if="group.id !==7  && group.id !==6" :key="key" :label="group.text">
                        <option v-for="(code, ckey) in group.children" :key="ckey" :value="code.id">{{code.text}}</option>
                    </optgroup>
                </select2>
            </div>
        </td>
        <td>

        </td>
    </tr>
    <tr v-if="akgTable.utilization_id_one ==codeKEV">
        <td colspan="2">

        </td>
        <td>
            <div class="form-group">
                <input class="form-control form-control-sm"
                           :disabled="akgTable.isDisabled"
                           v-tooltip="'Az elsödleges vetés területe '+akgTable.area_three+' (ha)'"
                           v-bind:class="{'is-invalid':!area_three_is_valid ||  parseFloatValue(ketArea) < parseFloatValue(akgTable.area_three),
                                           'is-valid': area_three_is_valid }"
                           type="text"
                           placeholder="Ter. 3."
                           v-model="akgTable.area_three">
                <transition name="fade">
                    <span class="invalid-feedback"
                              v-if="!area_three_is_valid">
                            A terület számnak kell lennie.
                        </span>
                </transition>
                <transition name="fade">
                    <span class="invalid-feedback"
                              v-if="parseFloatValue(ketArea) < parseFloatValue(akgTable.area_three)">
                            A terület nem lehet nagyobb mint a KET területe: {{ketArea}} ha.
                        </span>
                </transition>
            </div>
        </td>
        <td>
            <div class="form-group">
                <select2 :disabled="akgTable.isDisabled" v-if="akgProgramId === 9" class="akg-table-select" :width="'77px'" :placeholder="'Kód...'" v-model="akgTable.utilization_id_three">
                    <option disabled value="0">Kód...</option>
                    <optgroup v-for="(group, key) in tableCodes" v-if="group.id !==7" :key="key" :label="group.text">
                        <option v-for="(code, ckey) in group.children" v-if="!code.hasHoe" :key="ckey" :value="code.id">{{code.text}}</option>
                    </optgroup>
                </select2>
                <select2 :disabled="akgTable.isDisabled" v-else class="akg-table-select" :width="'77px'" :placeholder="'Kód...'" v-model="akgTable.utilization_id_three">
                    <option disabled value="0">Kód...</option>
                    <optgroup v-for="(group, key) in tableCodes" v-if="group.id !==7  && group.id !==6" :key="key" :label="group.text">
                        <option v-for="(code, ckey) in group.children" :key="ckey" :value="code.id">{{code.text}}</option>
                    </optgroup>
                </select2>
            </div>
        </td>
    </tr>
    <tr v-if="akgTable.utilization_id_one == codeKEV ">
        <td colspan="2">

        </td>
        <td>
            <div class="form-group">
                <input class="form-control form-control-sm"
                           :disabled="akgTable.isDisabled"
                           v-tooltip="'Az elsödleges vetés területe '+akgTable.area_four+' (ha)'"
                           v-bind:class="{'is-invalid':!area_four_is_valid || parseFloatValue(ketArea) < parseFloatValue(akgTable.area_four),
                                           'is-valid': area_four_is_valid }"
                           type="text"
                           placeholder="Ter. 4."
                           v-model="akgTable.area_four"
                           @input="$v.akgTable.area_four.$touch()">
                <transition name="fade">
                    <span class="invalid-feedback"
                              v-if="!area_four_is_valid">
                            A terület számnak kell lennie.
                        </span>
                </transition>
                <transition name="fade">
                    <span class="invalid-feedback"
                              v-if="parseFloatValue(ketArea) < parseFloatValue(akgTable.area_four)">
                            A terület nem lehet nagyobb mint a KET területe: {{ketArea}} ha.
                        </span>
                </transition>
            </div>
        </td>
        <td>
            <div class="form-group">
                <select2 :disabled="akgTable.isDisabled" v-if="akgProgramId === 9" class="akg-table-select" :width="'77px'" :placeholder="'Kód...'" v-model="akgTable.utilization_id_four">
                    <option disabled value="0">Kód...</option>
                    <optgroup v-for="(group, key) in tableCodes" v-if="group.id !==7" :key="key" :label="group.text">
                        <option v-for="(code, ckey) in group.children" v-if="!code.hasHoe" :key="ckey" :value="code.id">{{code.text}}</option>
                    </optgroup>
                </select2>
                <select2 :disabled="akgTable.isDisabled" v-else class="akg-table-select" :width="'77px'" :placeholder="'Kód...'" v-model="akgTable.utilization_id_four">
                    <option disabled value="0">Kód...</option>
                    <optgroup v-for="(group, key) in tableCodes" v-if="group.id !==7  && group.id !==6" :key="key" :label="group.text">
                        <option v-for="(code, ckey) in group.children" :key="ckey" :value="code.id">{{code.text}}</option>
                    </optgroup>
                </select2>
            </div>
        </td>
    </tr>
    <tr v-if="akgTable.utilization_id_one == codeKEV">
        <td colspan="2">

        </td>
        <td>
            <div class="form-group">
                <input class="form-control form-control-sm "
                           :disabled="akgTable.isDisabled"
                           v-tooltip="'Az elsödleges vetés területe '+akgTable.area_five+' (ha)'"
                           v-bind:class="{'is-invalid':!area_five_is_valid || parseFloatValue(ketArea) < parseFloatValue(akgTable.area_five),
                                           'is-valid':  area_five_is_valid }"
                           type="text"
                           placeholder="Ter. 5."
                           v-model="akgTable.area_five">
                <transition name="fade">
                    <span class="invalid-feedback"
                              v-if="!area_five_is_valid">
                            A terület számnak kell lennie.
                        </span>
                </transition>
                <transition name="fade">
                    <span class="invalid-feedback"
                              v-if="parseFloatValue(ketArea) < parseFloatValue(akgTable.area_five)">
                            A terület nem lehet nagyobb mint a KET területe: {{ketArea}} ha.
                        </span>
                </transition>
            </div>
        </td>
        <td>
            <div class="form-group">
                <select2 :disabled="akgTable.isDisabled" v-if="akgProgramId === 9" class="akg-table-select" :width="'77px'" :placeholder="'Kód...'" v-model="akgTable.utilization_id_five">
                    <option disabled value="0">Kód...</option>
                    <optgroup v-for="(group, key) in tableCodes" v-if="group.id !==7" :key="key" :label="group.text">
                        <option v-for="(code, ckey) in group.children" v-if="!code.hasHoe" :key="ckey" :value="code.id">{{code.text}}</option>
                    </optgroup>
                </select2>
                <select2 :disabled="akgTable.isDisabled" v-else class="akg-table-select" :width="'77px'" :placeholder="'Kód...'" v-model="akgTable.utilization_id_five">
                    <option disabled value="0">Kód...</option>
                    <optgroup v-for="(group, key) in tableCodes" v-if="group.id !==7  && group.id !==6" :key="key" :label="group.text">
                        <option v-for="(code, ckey) in group.children" :key="ckey" :value="code.id">{{code.text}}</option>
                    </optgroup>
                </select2>
            </div>
        </td>
    </tr>
</tbody>
</template>

<script>
import Select2 from "./Select2";
import CoppyKetRowTable from "./CoppyKetRowTable";
import swal from "sweetalert2";

import {
    required,
    maxLength,
    maxValue,
    helpers,
    numeric,
    requiredIf
} from "vuelidate/lib/validators";

export default {
    created() {
        //konstansok!
        this.codeKEV = window.akgConstants.codeKEV;
        this.codeATAD = window.akgConstants.codeATAD;
        this.codeKNK0 = window.akgConstants.codeKNK0;
    },

    components: {
        Select2,
        CoppyKetRowTable
    },

    props: [
        "akgTable",
        "ketArea",
        "codes",
        "lastElement",
        "tables",
        "areaOne",
        "akgTableUnwatch",
        "akgProgramId"
    ],
    computed: {
        // a computed getter
        tableCodes: function () {
            // `this` points to the vm instance
            var computedCodes = [];

            loop1: for (let group of this.codes) {

                var newGroup = {
                    id: group.id,
                    text: group.text,
                    children: []
                };

                loop2: for (let code of group.children) {

                    var prop;

                    if (this.akgTable.year < 2017) {
                        prop = 'text_' + this.akgTable.year;
                    } else {
                        prop = 'text_2017';
                    }

                    var text = code[prop];

                    if (text) {

                        var newCode = {
                            hasHoe: code.code,
                            text: text,
                            id: code.id,
                        }

                        newGroup.children.push(newCode);
                    }

                }

                computedCodes.push(newGroup);
            }

            return computedCodes
        }
    },
    data() {
        return {
            area_one_is_valid: true,
            area_two_is_valid: true,
            area_three_is_valid: true,
            area_four_is_valid: true,
            area_five_is_valid: true,
            isDragEffect: false,
            isDropEffect: false,
            isCopy: false,
            checker: new UtilizationCodeChecker(),
            valName: "validateArea",
            form: new Form({
                field: "",
                value: "",
                tableId: ""
            })
        };
    },

    validations: {
        akgTable: {
            identification: {
                required,
                numeric
            },
            name: {
                maxLength: maxLength(10)
            }
        }
    },
    watch: {
        "akgTable.identification": function (identification) {
            if (this.akgTableUnwatch) {
                return;
            }
            if (this.$v.akgTable.identification.$invalid) {
                return;
            }
            this.save("identification", identification);
        },
        "akgTable.name": function (name) {
            if (this.akgTableUnwatch) {
                return;
            }
            if (this.$v.akgTable.name.$invalid) {
                return;
            }
            this.save("name", name);
        },

        "akgTable.area_one": function (area_one) {
            if (this.akgTableUnwatch) {
                return;
            }

            this.isFloatValue("area_one", area_one);
            if (this.area_one_is_valid) {
                this.save("area_one", area_one);
                this.$emit("updated", this.akgTable.year);
            }
        },
        "akgTable.area_two": function (area_two) {
            if (this.akgTableUnwatch) {
                return;
            }

            this.isFloatValue("area_two", area_two);
            if (this.area_two_is_valid) {
                this.save("area_two", area_two);
                this.$emit("updated", this.akgTable.year);
            }
        },
        "akgTable.area_three": function (area_three) {
            if (this.akgTableUnwatch) {
                return;
            }

            this.isFloatValue("area_three", area_three);
            if (this.area_three_is_valid) {
                this.save("area_three", area_three);
                this.$emit("updated", this.akgTable.year);
            }
        },
        "akgTable.area_four": function (area_four) {
            if (this.akgTableUnwatch) {
                return;
            }
            this.isFloatValue("area_four", area_four);
            if (this.area_four_is_valid) {
                this.save("area_four", area_four);
                this.$emit("updated", this.akgTable.year);
            }
        },
        "akgTable.area_five": function (area_five) {
            if (this.akgTableUnwatch) {
                return;
            }
            this.isFloatValue("area_five", area_five);
            if (this.area_five_is_valid) {
                this.save("area_five", area_five);
                this.$emit("updated", this.akgTable.year);
            }
        },
        "akgTable.utilization_id_one": function (
            utilization_id_one_new,
            utilization_id_one_old
        ) {
            if (this.akgTableUnwatch) {
                return;
            }
            if (utilization_id_one_old === this.codeKEV) {
                this.setDefaultData();
            }

            if (
                utilization_id_one_new == this.codeATAD &&
                utilization_id_one_old != this.codeATAD
            ) {
                this.$emit("unwatch");
                return this.$emit("setMagicCode", this.akgTable.id);
            }

            if (
                utilization_id_one_old == this.codeATAD &&
                utilization_id_one_new != this.codeATAD
            ) {
                this.$emit("unwatch");

                return this.$emit(
                    "unSetMagicCode",
                    this.akgTable.id,
                    this.akgTable.utilization_id_one
                );
            }
            this.save("utilization_id_one", utilization_id_one_new);
            this.$emit("updated", this.akgTable.year);
            this.checker.check(utilization_id_one_new, this.akgTable.area_one);
        },
        "akgTable.utilization_id_two": function (utilization_id_two) {
            if (this.akgTableUnwatch) {
                return;
            }
            this.save("utilization_id_two", utilization_id_two);
            this.$emit("updated", this.akgTable.year);
            this.checker.check(utilization_id_two, this.akgTable.area_two);
        },
        "akgTable.utilization_id_three": function (utilization_id_three) {
            if (this.akgTableUnwatch) {
                return;
            }
            this.save("utilization_id_three", utilization_id_three);
            this.$emit("updated", this.akgTable.year);
            this.checker.check(utilization_id_three, this.akgTable.area_three);
        },
        "akgTable.utilization_id_four": function (utilization_id_four) {
            if (this.akgTableUnwatch) {
                return;
            }
            this.save("utilization_id_four", utilization_id_four);
            this.$emit("updated", this.akgTable.year);
            this.checker.check(utilization_id_four, this.akgTable.area_four);
        },
        "akgTable.utilization_id_five": function (utilization_id_five) {
            if (this.akgTableUnwatch) {
                return;
            }
            this.save("utilization_id_five", utilization_id_five);
            this.$emit("updated", this.akgTable.year);
            this.checker.check(utilization_id_five, this.akgTable.area_five);
        }
    },

    methods: {
        isFloatValue(field, value) {
            var validatedfield = field + "_is_valid";

            if (typeof value == "string") {
                var value = value.replace(",", ".");
            }

            if (value == "" || value == null) {
                return (this[validatedfield] = true);
            }

            if (
                (Number(value) == value && value % 1 === 0) ||
                (Number(value) == value && value % 1 !== 0)
            ) {
                return (this[validatedfield] = true);
            } else {
                return (this[validatedfield] = false);
            }
        },

        parseFloatValue(value) {

            if (typeof value == "string") {
                value = value.replace(",", ".");
            }

            return parseFloat(value);

        },

        setDefaultData() {
            this.akgTable.area_three = null;
            this.akgTable.area_four = null;
            this.akgTable.area_five = null;

            this.akgTable.utilization_id_three = null;
            this.akgTable.utilization_id_four = null;
            this.akgTable.utilization_id_five = null;
        },
        firstTableArea() {
            return this.tables[0].area_one;
        },
        dragstart_handler(ev) {
            // Add the target element's id to the data transfer object
            this.isDragEffect = true;
            ev.dataTransfer.setData("int", this.akgTable.id);
            ev.dropEffect = "move";
        },

        drag_leave_handler(ev) {
            this.isDropEffect = false;
        },
        dragover_handler(ev) {
            this.isDropEffect = true;
            ev.preventDefault();
            // Set the dropEffect to move
            ev.dataTransfer.dropEffect = "move";
        },
        drop_handler(ev) {
            ev.preventDefault();
            // Get the id of the target and add the moved element to the target's DOM
            if (this.akgTable.isDisabled) {
                this.isDragEffect = false;
                this.isDropEffect = false;
                return alert("Nem nem! Nem szabad! :)");
            }
            var data = {
                copyedTableId: parseInt(ev.dataTransfer.getData("int")),
                targetTableId: this.akgTable.id
            };
            this.isDragEffect = false;
            this.isDropEffect = false;

            this.$emit("dragAndDropCopy", data);
        },

        save: _.debounce(function (field, value) {
            if (
                field == "area_one" ||
                field == "area_two" ||
                field == "area_three" ||
                field == "area_four" ||
                field == "area_five"
            ) {
                if (typeof value == "string") {
                    var value = value.replace(",", ".");
                }
            }

            this.form.tableId = this.akgTable.id;
            this.form.value = value;
            this.form.field = field;

            this.form
                .post("ajax/akgTable/saveTable")
                .then(function () {
                    $.growl.notice({
                        title: "Sikeres mentés!",
                        message: "A módosítások mentése sikeresen megtörtént."
                    });
                })
                .catch(e => {
                    $.growl.error({
                        title: "Hiba!",
                        message: "A módosítások mentése nem sikrült."
                    });
                    swal({
                        type: "error",
                        title: "Hiba!",
                        html: e.message,
                        confirmButtonColor: "#3fa535",
                        confirmButtonText: "Rendben"
                    });
                    this.akgTable[field] = "";
                });
        }, 100)
    }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/AkgTable.vue